import WhoCanJoin from "./whoCanJoin";

export default WhoCanJoin;
